module.exports = __webpack_public_path__ + "fonts/054de12.otf";